import React, {Component} from 'react'
import {Navbar, Nav} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import './CustomNavbar.css'
import logo from '../resources/logo_white.svg';

const isMobile = window.innerWidth <= 500;
const scrollLim = isMobile ? 150 : 300;

export default class CustomNavbar extends Component {
    state = {
        style: {
            marginTop: isMobile ? '1.0rem' : '0rem',
            backgroundColor: this.props.initColor
        }
    };

    constructor(props) {
        super(props);
    }

    listenScrollEvent = e => {
        if (window.scrollY > scrollLim){
            this.setState({
                style: {
                    marginTop: isMobile ? '0.9rem' : '0rem',
                    backgroundColor: '#000000BF',
                    maxWidth: '100vw'
                }
            })
        }
        else {
            this.setState({
                style: {
                    marginTop: isMobile ? '1.3rem' : '0rem',
                    backgroundColor: this.props.initColor,
                    maxWidth: '100vw'
                }
            })
        }

    };

    componentDidMount () {
        window.addEventListener('scroll', this.listenScrollEvent);
    }


    render() {

        let {appData, initColor} = this.props;
        const logoWidth = Math.floor(appData.isMobile ? 172 * 0.7 : 172 * 0.8);
        const logoHeight = Math.floor(appData.isMobile ? 72 * 0.7 : 72 * 0.8);
        const menuItemPadding = appData.isMobile ? '0.7rem' : '1.0rem';
        return (
            <Navbar style={this.state.style} collapseOnSelect expand="lg" fixed="top" variant="dark" center>
                {appData.isMobile &&
                <Navbar.Brand>
                    <Link to="/">
                        <img src={logo} height={logoHeight.toString()} width={logoWidth.toString()} alt="ORZW logo"/>
                    </Link>
                </Navbar.Brand>
                }
                <Navbar.Toggle style={{color: 'white'}} aria-controls="responsive-navbar-nav"/>
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mx-auto">
                        {!appData.isMobile &&
                        <Navbar.Brand>
                            <Link to="/">
                                <img src={logo} height={logoHeight.toString()} width={logoWidth.toString()} alt="ORZW logo"/>
                            </Link>
                        </Navbar.Brand>
                        }
                        <Nav.Link href="/" style={{color: 'white', padding: menuItemPadding}}>GŁÓWNA</Nav.Link>
                        <Nav.Link href="/about" style={{color: 'white', padding: menuItemPadding}}>O OŚRODKU</Nav.Link>
                        <Nav.Link eventKey={2} href="/contact" style={{color: 'white', padding: menuItemPadding}}>KONTAKT</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

